import React, { memo, useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
  selectTenantName,
} from "../../../app/applicationSlice"
import {
  AXIOS_IP,
  beforeUploadFile,
  customRequest,
  downloadFile,
  findDuplicateFinallyIds,
  generateTempId,
} from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"
import { EditableList } from "../../../compnents/list/EditableList"
import { KJYWCatalogColumns, SSJSSCatalogColumns } from "../columns"
import {
  validateArrayDataFirstError,
  validateRequiredFields,
} from "../AntimicrobialDrugs/validate"

export const SSJSSFormModal = (props: {
  visible: boolean
  token: string
  againId?: string
  memo?: string
  fileData?: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [pageLoading, setPageLoading] = useState(false)

  const [data, setData] = useState<any[]>([])

  const [fileUrl, setfileUrl] = useState<any>([])

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const requiredList = [
    { name: "手术操作名称", key: "procedureName", required: true },
  ]

  //报备表
  const templateData = {
    fileConfigId: "5",
    fileName: "报备表模板",
    fileType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    filePath: "228f717dbde7f499ea4188547cc7a09b54e0973b82c9efb060ffb8e90498ed08.xlsx",
  }

  // 自定义上传实现
  const customRequestFn = (options: any) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      setfileUrl([...fileUrl, newurl])
    })
  }

  const handleRemove = (type: string, index: number) => {
    setfileUrl(fileUrl?.filter((v: any, i: number) => i !== index))
  }

  useEffect(() => {
    form.setFieldsValue({
      reportFile: fileUrl,
    })
  }, [fileUrl])

  useEffect(() => {
    if (props.visible) {
      if (props.againId) {
        setPageLoading(true)
        axios({
          url: `${AXIOS_IP}/filingSurgicalDirectory/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: {
            id: props.againId,
            pageNo: 1,
            pageSize: 1000,
          },
        })
          .then((res) => {
            setfileUrl(props.fileData|| [])
            const data = res.data.data
            setData(
              data?.list?.map((v: any) => { return {...v, finallyId: v.id, id: generateTempId()} })?.concat([{ id: generateTempId() }])
            )
          })
          .finally(() => {
            setPageLoading(false)
          })
      } else {
        if (!data.length) {
          setData([{ id: generateTempId() }])
        }
      }
    } else {
      setData([])
      setfileUrl([])
    }
  }, [props.visible, props.againId, props.fileData])

  return (
    <>
      <Modal
        title="三四级手术目录报备"
        width={1300}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={() => {
          const msg = validateArrayDataFirstError(
            data?.slice(0, -1),
            requiredList
          )
          if (data?.length <= 1) {
            return
          }
          if (msg.isValid) {
            form.submit()
          } else {
            notification.warning({
              message: msg.error.message,
            })
          }
        }}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              const result = findDuplicateFinallyIds(data?.slice(0, -1))
              console.log(result);
              if(result.length > 0) {
                notification.error({
                  message: `存在重复手术操作名称，重复手术操作名称为：${result.join("，")}`,
                  duration: 3
                })
              } else {
                setSubmitVisible(true)
              }
            }}
          >
            <Form.Item label="报备表" name="reportFile" rules={[{ required: true}]}>
              <Row align="middle">
                <Upload
                  customRequest={(options) => customRequestFn(options)}
                  beforeUpload={(file) => beforeUploadFile(file, fileUrl)}
                  showUploadList={false}
                  maxCount={1}
                  accept={".pdf"}
                >
                  <Button icon={<PlusOutlined />}>上传</Button>
                </Upload>
                <span style={{ padding: "0 10px 0 15px" }}>
                    文件格式加盖公章的pdf版。
                  </span>
                  <a style={{ textDecoration: "underline", paddingRight: 10 }} 
                    onClick={() => downloadFile(templateData, props.token, 'xlsx')}
                    >
                      参考模板
                  </a>
                {fileUrl?.length > 0 &&
                  fileUrl?.map((v: any, index: number) => {
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          paddingLeft: 10,
                        }}
                      >
                        <span style={{ paddingRight: 10 }}>
                          {v.fileName}{" "}
                          <a
                            style={{ paddingLeft: 10 }}
                            onClick={() => setPreviewFile(v)}
                          >
                            查看
                          </a>
                        </span>
                        <CloseOutlined
                          style={{
                            position: "relative",
                            top: 2,
                            color: "rgb(161 161 161)",
                          }}
                          onClick={() => {
                            handleRemove("MD", index)
                          }}
                        />
                      </div>
                    )
                  })}
              </Row>
            </Form.Item>
          </Form>
          <EditableList
            style={{ marginTop: "15px" }}
            scroll={{ y: "450px" }}
            dataSource={data}
            loading={pageLoading}
            pagination={false}
            rowKey={(m: any) => m.id}
            columns={SSJSSCatalogColumns(
              AXIOS_IP,
              props.token,
              props.visible,
              (text, t) => {
                if (text == "edit") {
                  const result = validateRequiredFields(t, requiredList)
                  const flag = data.findIndex((d) => d.id === t.id) === data.length - 1
                  const newData = data.map((item: any) => {
                    if (item.id == t.id) {
                      return t
                    } else {
                      return item
                    }
                  })

                  setData(
                    result
                      ? newData
                      : flag //判断是否为最新一行，是的就添加一行
                      ? data?.length >= 1000
                        ? newData
                        : newData.concat([{ id: generateTempId() }])
                      : newData
                  )
                } else if (text == "remove") {
                  const flag =
                    data.findIndex((d) => d.id === t.id) === data.length - 1
                  if (flag) {
                    setData(
                      data.map((item: any) => {
                        if (item.id == t.id) {
                          return { id: generateTempId() }
                        } else {
                          return item
                        }
                      })
                    )
                  } else {
                    setData(data.filter((item: any) => item.id != t.id))
                  }
                }
              }
            )}
            sticky
          />
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={600}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const params = {
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            id: props.againId || undefined,
            reportFile: fileUrl,
            idAndMemo: data?.slice(0, -1)?.map((d: any) => {
              return {
                id: d.finallyId,
                memo: d.memo,
              }
            }),
          }
          axios({
            url: `${AXIOS_IP}/filingSurgicalDirectory/saveOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data: params,
          })
            .then(() => {
              setSubmitVisible(false)
              notification.success({
                message: "操作成功",
              })
              props.onOk()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 100 }}>
          提交后请耐心等待工作人员审核，如有任何疑问请拨打400-888888
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
